import { usePwaInstall } from '../../hooks/usePwaInstall'
import InstallAppButton from './InstallAppButton'

// Bloque secundario "Instalar aplicación" para pantallas públicas (sin sesión).
// No se renderiza nada si la app ya está instalada o no hay forma de instalarla.
export default function InstallAppPrompt({ className = '' }) {
  const installState = usePwaInstall()
  if (!installState.shouldShow) return null

  return (
    <div className={className}>
      <div className="flex items-center gap-3 text-xs font-medium uppercase tracking-wider text-text-secondary" aria-hidden="true">
        <span className="h-px flex-1 bg-border" />o<span className="h-px flex-1 bg-border" />
      </div>
      <p className="mt-4 text-center text-sm text-text-secondary">¿Quieres tener CSPAH en tu celular?</p>
      <div className="mt-3"><InstallAppButton installState={installState} variant="secondary" /></div>
    </div>
  )
}
